/* =========================================================
   EYESHELLS: Split engo-scripts.js -> engo-core.js (global)
   - Keeps header search/autocomplete, minicart, menus, popups, toolbar behavior
   - Keeps back-to-top / chat avoidance helper
   - Adds small global initializers (toolbar scroll + popup recommended slider)
// =========================================

/*
  Legacy swatch click handler removed.
  (It set BOTH primary+secondary images to the same URL, which made hover swap look "broken".)
  Swatch behavior is now handled by assets/es-swatch-ES.js (capturing) + the theme's updated logic.
*/

/* Live search */
var engoAutoComplate = {
  initProductsRecently: function() {
    var self = this;
    if (!jQuery.cookie('brilliant_products_recently') || jQuery.cookie('brilliant_products_recently') == null) {      
      $(".engoj-recently-wrapper").append('<div class="no-products" style="flex-direction: column;"> <!--?xml version="1.0" encoding="iso-8859-1"?--> <!-- Generator: Adobe Illustrator 17.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --> <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewbox="0 0 455 455" style="enable-background:new 0 0 455 455;" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve"> <g> <path d="M360.967,130.599c-4.06-0.818-8.018,1.8-8.841,5.86c-0.823,4.06,1.801,8.018,5.86,8.841 c1.147,0.232,2.013,1.286,2.013,2.45v160c0,1.355-1.145,2.5-2.5,2.5H179.676c-4.142,0-7.5,3.357-7.5,7.5s3.358,7.5,7.5,7.5H357.5 c9.649,0,17.5-7.851,17.5-17.5v-160C375,139.46,369.099,132.247,360.967,130.599z"></path> <path d="M274.824,130.25H97.5c-9.649,0-17.5,7.851-17.5,17.5v160c0,8.063,5.48,15.046,13.326,16.982 c0.604,0.149,1.208,0.221,1.803,0.221c3.369,0,6.432-2.287,7.276-5.705c0.992-4.021-1.463-8.086-5.484-9.078 c-0.955-0.235-1.92-1.143-1.92-2.42v-160c0-1.355,1.145-2.5,2.5-2.5h177.324c4.142,0,7.5-3.357,7.5-7.5 S278.966,130.25,274.824,130.25z"></path> <path d="M235.363,170.798c-2.655-0.363-5.3-0.548-7.863-0.548c-31.706,0-57.5,25.794-57.5,57.5c0,2.563,0.185,5.209,0.548,7.863 c0.515,3.759,3.731,6.483,7.421,6.483c0.339,0,0.682-0.023,1.027-0.07c4.104-0.562,6.975-4.345,6.413-8.448 c-0.271-1.982-0.409-3.943-0.409-5.828c0-23.435,19.065-42.5,42.5-42.5c1.884,0,3.845,0.138,5.828,0.409 c4.108,0.564,7.886-2.309,8.448-6.413C242.338,175.143,239.467,171.359,235.363,170.798z"></path> <path d="M219.127,284.636c2.789,0.407,5.605,0.614,8.373,0.614c31.706,0,57.5-25.794,57.5-57.5c0-2.77-0.207-5.587-0.613-8.373 c-0.599-4.099-4.408-6.934-8.505-6.337c-4.099,0.599-6.936,4.406-6.337,8.505c0.303,2.071,0.456,4.158,0.456,6.205 c0,23.435-19.065,42.5-42.5,42.5c-2.044,0-4.132-0.153-6.205-0.456c-4.099-0.6-7.907,2.238-8.505,6.337 S215.028,284.037,219.127,284.636z"></path> <path d="M318.5,203.25c9.098,0,16.5-7.402,16.5-16.5c0-8.318-6.227-15.355-14.484-16.37c-2.293-0.277-4.585,0.509-6.218,2.142 l-10.027,10.027c-1.633,1.632-2.422,3.926-2.141,6.217C303.145,197.023,310.183,203.25,318.5,203.25z"></path> <path d="M117.5,114.75h30c4.142,0,7.5-3.357,7.5-7.5s-3.358-7.5-7.5-7.5h-30c-4.142,0-7.5,3.357-7.5,7.5 S113.358,114.75,117.5,114.75z"></path> <path d="M388.367,66.633C345.397,23.664,288.268,0,227.5,0S109.603,23.664,66.633,66.633C23.664,109.603,0,166.732,0,227.5 s23.664,117.897,66.633,160.867C109.603,431.336,166.732,455,227.5,455s117.897-23.664,160.867-66.633 C431.336,345.397,455,288.268,455,227.5S431.336,109.603,388.367,66.633z M15,227.5C15,110.327,110.327,15,227.5,15 c55.894,0,106.807,21.703,144.783,57.11L72.11,372.283C36.703,334.307,15,283.395,15,227.5z M227.5,440 c-55.894,0-106.807-21.703-144.783-57.11L382.89,82.717C418.297,120.693,440,171.606,440,227.5C440,344.673,344.673,440,227.5,440z "></path> </g> </svg> <div class="title_noprod"> <span> Sorry, there are no products. </span> </div> </div>');
    } else {
      $(".engoj-recently-wrapper > .no-products").remove();
      var arr = jQuery.cookie('brilliant_products_recently').split('|'); // split string to array
      for ( var i = 0; i < arr.length; i++){
        var handle = arr[i]; 
        self.ajaxProductsRecently(handle);
      }

      $('.js_prod_recent').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        infinite: false,
        vertical: true,
        verticalSwiping: true,
        focusOnSelect: true,
        prevArrow: '<button type="button" class="slick-brand-prev fa-solid fa-angle-left"></button>',
        nextArrow: '<button type="button" class="slick-brand-next fa fa-angle-down"></button>',

        responsive: [
          {
            breakpoint: 1200,
            settings: {
            }
          },
          {
            breakpoint: 768,
            settings: {
            }
          },

          {
            breakpoint: 574,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
      });
    }
  },

  ajaxProductsRecently: function(handle) {
    var ajaxUrl = '/products/'+handle+'.js',
        result     = new Array();
    jQuery.ajax({
      type: 'GET',
      dataType: "json",
      url: ajaxUrl,
      beforeSend: function() {
        jQuery(".js_prod_recent").append('<div class="items d-flex align-items-md-center align-items-start engoj-recently-'+handle+'"><svg xml:space="preserve" style="enable-background:new 0 0 50 50;margin-top: -1px;" viewBox="0 0 24 30" height="20px" width="21px" y="0px" x="0px" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" id="Layer_1" version="1.1"><rect opacity="0.2" fill="#000" height="8" width="3" y="10" x="0"><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect><rect opacity="0.2" fill="#000" height="8" width="3" y="10" x="8">      <animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect><rect opacity="0.2" fill="#000" height="8" width="3" y="10" x="16"><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect></svg></div>');
      },
      success: function(product) {
        var title            = product.title,
            price            = product.price,
            handle           = product.handle,
            image            = product.featured_image,
            template         = '<div class="img_left"> <a href="/products/'+ handle +'"> <img src="' + image + '" class="img-responsive" alt="'+title+'"> </a> </div> <div class="info_right position-absolute"> <a class="product-title" href="/products/'+ handle +'">'+title+'</a> <p class="price-product"><span class="price">'+ Shopify.formatMoney(price, window.money_format) +'</span></p> <div class="product-icon-action"> <div class="add-to-cart"> <a href="/products/'+ handle +'"><span>Buy now</span></a> </div> </div> </div>';       
            jQuery('.engoj-recently-'+handle).html(template);
      }
    });
  },

  ajaxProductItems : function( input_element, result_wrapper, result_element ){
    var ajaxUrl  = '/search',
        result     = new Array(),
        keyword   = input_element.val();

    jQuery.ajax({
        type: 'GET',
        data: {
            q: "*" + keyword + "*",
            type: "product",
            view: "json",
        },
        dataType: "json",      
        url: ajaxUrl,
        beforeSend: function() {
          result_wrapper.show();
          result_element.html('<p class="col-12"><svg xml:space="preserve" style="enable-background:new 0 0 50 50;margin-top: -1px;" viewBox="0 0 24 30" height="20px" width="21px" y="0px" x="0px" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" id="Layer_1" version="1.1"><rect opacity="0.2" fill="#000" height="8" width="3" y="10" x="0"><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect><rect opacity="0.2" fill="#000" height="8" width="3" y="10" x="8">      <animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect><rect opacity="0.2" fill="#000" height="8" width="3" y="10" x="16"><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect></svg> Loading...</p>');
        },
        complete:function(){
        },
        success: function ( reponse ) {
          var htmlbox = '';
          //result_element.html('');
          if( reponse.length > 0 ){
            for (var i = 0; i < reponse.length; i++) {

              var item              = reponse[i],
                  title            = item.title,
                  price            = item.price,
                  handle           = item.handle,
                  image            = item.featured_image,
                  compare_price    = item.compare_at_price  ? '<s class="price-old">' + Shopify.formatMoney(item.compare_at_price, window.money_format) + '</s>' : "",
                  sold_out	       = item.available          ? "" : "<span class='item-sold-out'>Out of stock</span> ",
                  price            = item.available          ? item.price : item.out_stock_nofication,
                  hightlight     = title.replace(new RegExp('(' + keyword + ')', 'gi'), '<span class="hightlight">$1</span>'),
                  template         = '<div class="col-lg-4 col-sm-6 col-md-6"><ul class="prod_sidebar"><li class="product_info">'
                                      + '<a href="/products/'+ handle +'">'
                                      + '<img style="width: 100% "src="' + image + '" class="img-responsive"/>' 
                                      +'</a>'
                                      +'<h4 class="title-product"><a href="/products/'+ handle +'">' + hightlight +'</a></h4>'
                                      +'<span><p class="price-product mb-0"><span class="price">'+ Shopify.formatMoney(price, window.money_format) +'</span>'+ compare_price +'</p></span>'
                  					  + sold_out
                                      +'</li></ul></div>';
              htmlbox = htmlbox + template;
                 

            }
            result_element.html(htmlbox);
            
            if($('.js_productSearchResults .js_search_results li').length){
              $('.js_productSearchResults').show();
           
            }
          }else{
            result_element.html('<p class="col-12">No result found for your search.</p>');
             $('.js_productSearchResults').show();
          }
       }     
    });

  },
  
  ajaxSearch : function( options ){    
    var     ajax_timeout,
    		ajax_lost_focus,
            self        = this,
            search_input_id    = options.search_input.length   > 0   ? options.search_input    : '.js_engo_autocomplate',
            wrapper_id         = options.result_wrapper.length > 0   ? options.result_wrapper  : '.js_productSearchResults',
            result_id          = options.result_element.length > 0   ? options.result_element  : '.js_search_results';

    jQuery( document ).delegate( search_input_id ,'keyup',function( event ){
      if (jQuery(this).data('esSearchEnhanced')) { return; }
      var keyword           = jQuery(this).val(),
          search_element    = jQuery(this),
          result_wrapper    = jQuery( wrapper_id ),
          result_element    = result_wrapper.children( result_id );
        
      if( ajax_timeout ){ 
        clearTimeout(ajax_timeout);
      } 

      ajax_timeout = setTimeout(function() {
        if( keyword.length >= 2 ){
            self.ajaxProductItems( search_element ,result_wrapper, result_element );
        }else{
            result_element.html('<p class="col-12">You must enter at least 2 characters.</p>');
        } 
      },300);       
    }); 

  },
  
  init : function( options ){
    this.ajaxSearch( options );
  }
  
}

jQuery(document).ready(function($) {  
  engoAutoComplate.init({
    "search_input"      :   ".js_engo_autocomplate",
    "result_wrapper"   :   ".js_productSearchResults",
    "result_element"   :   ".js_search_results"
  });
      
  engoAutoComplate.initProductsRecently();
});




jQuery(document).ready(function($) {
  /* ES: tooltips disabled site-wide */
  /* $('[data-toggle=\"tooltip\"]').tooltip(); */
  /* ES UX: disable tooltip for quickview icons (all pages) */
  try {
    var $qv = $('.engoj_btn_quickview, .icon-quickview, .quickview-link');
    if ($qv.length && $qv.tooltip) { $qv.tooltip('dispose'); }
    $qv.removeAttr('data-toggle data-original-title title aria-describedby');
  } catch (e) {}
  $(document).on('mouseenter', '.engoj_btn_quickview, .icon-quickview, .quickview-link', function(){
    $(this).removeAttr('data-toggle data-original-title title aria-describedby');
  });
});





jQuery(document).ready(function($) {
  "use strict";




  function promo(){
    $('.close_promo_topbar').on('click',function(){
      $('.promo_topbar').addClass("active");
    });
  }

  function search(){
    $('.js-search-destop').on('click', function() {
      $('.js-box-search').addClass('active');
      $('.bg_search_box').addClass('active');
      $('body').addClass('activedestop');
    });
    $('.js-drawer-close').on('click', function() {
      $('.js-box-search').removeClass('active');
      $('.bg_search_box').removeClass('active');
      $('body').removeClass('activedestop');
    });
    $('.bg_search_box').on('click', function() {
      $('.js-box-search').removeClass('active');
      $('.bg_search_box').removeClass('active');
      $('body').removeClass('activedestop');
    });
  }

  function minicart(){
    // Eyeshells: robust minicart open/close (delegated so it keeps working even if markup is re-rendered)
    function esOpenMiniCart(){
      // Close filter drawer if open (prevents overlay/z-index conflicts)
      if ($('.filter-to-left').hasClass('active')) {
        $('.filter-to-left').removeClass('active');
      }

      $('.js-minicart').addClass('active');
      $('.bg-minicart').addClass('active');
      /* Eyeshells: prevent Shopify Inbox launcher from overlapping the cart subtotal/CTA */
      $('body').addClass('es-minicart-open');
    }
    function esCloseMiniCart(){
      $('.js-minicart').removeClass('active');

      // Backdrop is shared with the filter drawer in this theme.
      // Only remove it if filters are not open.
      if (!$('.filter-to-left').hasClass('active')) {
        $('.bg-minicart').removeClass('active');
      }

      $('body').removeClass('es-minicart-open');
    }

    $(document)
      .off('click.eyeshellsMinicart')
      .on('click.eyeshellsMinicart', '.js-call-minicart', function(e){
        e.preventDefault();
        esOpenMiniCart();
      })
      .on('click.eyeshellsMinicart', '.close-mini-cart, .mini-cart-undo, [data-minicart-close]', function(e){
        e.preventDefault();
        e.stopPropagation();
        esCloseMiniCart();
      })
      .on('click.eyeshellsMinicart', '.bg-minicart', function(e){
        if (!$('.js-minicart').hasClass('active')) return;
        e.preventDefault();
        esCloseMiniCart();
      });


    
/* Eyeshells: allow ESC to close open popups (minicart / quickview / filters / add-to-cart) */
$(document)
  .off('keyup.eyeshellsEscClose')
  .on('keyup.eyeshellsEscClose', function(e) {
    var key = e.key || e.keyCode;
    if (key !== 'Escape' && key !== 'Esc' && key !== 27) return;

    // 1) Quickview modal
    if ($('.quickview-product').hasClass('active') || $('.tshopify-popup').hasClass('active')) {
      $('.tshopify-popup, .quickview-product').removeClass('active');
      setTimeout(function(){ $('.loading').removeClass('loaded-content'); }, 300);
      return;
    }

    // 2) Ajax add-to-cart popup
    if ($('.engo-popup.active').length) {
      $('.engo-popup').removeClass('active');
      return;
    }

    // 3) Filter drawer
    if ($('.filter-to-left').hasClass('active')) {
      $('.filter-to-left').removeClass('active');
      // shared backdrop
      if (!$('.js-minicart').hasClass('active')) {
        $('.bg-minicart').removeClass('active');
      }
      return;
    }

    // 4) Mini cart drawer
    if ($('.js-minicart').hasClass('active')) {
      $('.js-minicart').removeClass('active');
      $('.bg-minicart').removeClass('active');
      $('body').removeClass('es-minicart-open');
      return;
    }
  });



/* Eyeshells: robust close for Ajax add-to-cart popup (X / overlay) even if other scripts stop bubbling */
(function() {
  if (window.__eyeshellsPopupCloseCaptureBound) return;
  window.__eyeshellsPopupCloseCaptureBound = true;

  function removeActive(selector) {
    var nodes = document.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.remove('active');
  }

  document.addEventListener('click', function(ev) {
    var t = ev.target;
    if (!t || !t.closest) return;

    // Ajax add-to-cart success popup
    if (t.closest('.product-popup .close-window') || t.closest('.product-popup .overlay-addcart') || t.closest('.product-popup .continue-shopping')) {
      removeActive('.product-popup');
      return;
    }

    // Error popup
    if (t.closest('.error-popup .close-window') || t.closest('.error-popup .overlay-addcart')) {
      removeActive('.error-popup');
      return;
    }
  }, true); // capture: run before bubble handlers

})();

/* Header badge cleanup (mobile)
   - Hide "0" on cart counter
   - Cap large numbers to 9+
   - Keep badge stable when updated by Ajax
*/
(function(){
  function formatCount(n){
    return (n > 9) ? '9+' : String(n);
  }

  function updateCartBadge(){
    var els = document.querySelectorAll('.enj-cartcount');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var n = parseInt((el.textContent || '').trim(), 10) || 0;
      if (n > 0) {
        el.classList.remove('es-badge-hidden');
        el.textContent = formatCount(n);
      } else {
        el.classList.add('es-badge-hidden');
        el.textContent = '';
      }
    }
  }

  function updateAll(){
    updateCartBadge();
    // Wishlist counter is handled in swym-custom.liquid (show-badge toggle + 0 hide)
  }

  function observe(){
    if (!window.MutationObserver) return;
    var root = document.querySelector('.menu_moblie') || document.querySelector('#header') || document.body;
    if (!root) return;
    var mo = new MutationObserver(function(){
      // Debounce via rAF to avoid overwork during rapid DOM writes
      if (observe._raf) return;
      observe._raf = requestAnimationFrame(function(){
        observe._raf = null;
        updateAll();
      });
    });
    mo.observe(root, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){
      updateAll();
      observe();
    });
  } else {
    updateAll();
    observe();
  }

  // Also listen for common cart update events if present
  document.addEventListener('cart:updated', updateAll);
  document.addEventListener('ajaxCart:updated', updateAll);
})();
  }

  function menuhorizon() {

    $('.js-model_menu').on('click', function() {
      $('.js-horizon-menu').addClass('active');
      $('.js-bg-horizon-menu').addClass('active');
      $('body').addClass('cartover');
    });

    $('.js_close-menu-horizon').on('click', function() {
      $('.js-horizon-menu').removeClass('active');
      $('.js-bg-horizon-menu').removeClass('active');
      $('body').removeClass('cartover');
    });

    $('.js-bg-horizon-menu').on('click', function() {
      $('.js-horizon-menu').removeClass('active');
      $('.js-bg-horizon-menu').removeClass('active');
      $('body').removeClass('cartover');
    });

  }

  function jsmenuiconh(){
    $('.js_icon_horizon-menu').on( 'click', function() {
      $(this).parents().addClass('active');
    });
    $('.js-back').on( 'click', function() {
      $(this).parents().parents().find('.menu-horizon-list').removeClass('active');
    });       


  }

  function jscalllogindestop(){
    $('.js-call-popup-login').on( 'click', function() {
      $('.js-poup-login-destop').addClass('active');
      $('.js-bg-login-popup').addClass('active');
    });
    $('.js-eveland-close-login').on( 'click', function() {
      $('.js-poup-login-destop').removeClass('active');
      $('.js-bg-login-popup').removeClass('active');
    });
    $('.js-bg-login-popup').on( 'click', function() {
      $('.js-poup-login-destop').removeClass('active');
      $('.js-bg-login-popup').removeClass('active');
    });
  }

  function jsBackLogin(){
    $('.jsCreate_account').on('click', function() {
      $('.form_register').show();
      $('.formlogin').hide();    
    });
    $('.tab_navar_right').on('click', function() {
      $('.formlogin').show();
      $('.form_register').hide();    
    });

    $('.jsBack_login').on('click', function() {
      $('.formlogin').show();
      $('.form_register').hide();        
    });
    $('.jsacount_destop').on('click', function() {
      $('.formlogin').show();
      $('.form_register').hide();        
    });
  }



  function jslogindestop(){
    $('.jsCreate_account').on('click', function() {
      $('.form_register-destop').show();
      $('.formlogin-destop').hide();    
    });
    $('.js-call-popup-login').on('click', function() {
      $('.formlogin-destop').show();
      $('.form_register-destop').hide();    
    });

    $('.jsBack_login').on('click', function() {
      $('.formlogin-destop').show();
      $('.form_register-destop').hide();        
    });
    $('.jsacount_destop').on('click', function() {
      $('.formlogin-destop').show();
      $('.form_register-destop').hide();        
    });
  }




  function mobilescroll() {
    var $nav = $(".jsmenumobile");
    $nav.removeClass('menu_mobilescroll');

    $(document).scroll(function() {

      $nav.toggleClass('menu_mobilescroll', $(this).scrollTop() > $nav.height());
    });
  }

  function menumobile() {
    $('.menuleft').on('click', function() {
      $(this).toggleClass('active');
      $('.box_contentmenu').toggleClass('active');     
      $('.box_contentmenu_background').toggleClass('active');   
	      // Keep a reliable "mobile menu open" state on <body>
	      // (used to hide floating UI like chat/back-to-top/video while the drawer is open)
	      var isOpen = $('.box_contentmenu').hasClass('active');
	      $('body').toggleClass('activemenu_mobile', isOpen);
    });
    $('.box_contentmenu_background').on('click', function() {
      $(this).removeClass('active');
      $('.box_contentmenu').removeClass('active');
      $('.menuleft').removeClass('active');
      $('.box_contentmenu_background').removeClass('active');
      $('body').removeClass('activemenu_mobile');
    });
    $('.js-eveland-close').on('click', function() {
      $(this).removeClass('active');
      $('.box_contentmenu').removeClass('active');
      $('.menuleft').removeClass('active');
      $('.box_contentmenu_background').removeClass('active');
      $('body').removeClass('activemenu_mobile');      
    });
  }

  function menutoolbar() {
    $('.btn_bar').on('click', function() {
      $(this).toggleClass('active');
      $('.box_contentmenu').toggleClass('active');     
      $('.box_contentmenu_background').toggleClass('active');     
	      var isOpen = $('.box_contentmenu').hasClass('active');
	      $('body').toggleClass('activemenu_mobile', isOpen);
    });
    $('.box_contentmenu_background').on('click', function() {
      $(this).removeClass('active');
      $('.box_contentmenu').removeClass('active');
      $('.menuleft').removeClass('active');
      $('.box_contentmenu_background').removeClass('active');
	      $('body').removeClass('activemenu_mobile');
    });
    $('.js-eveland-close').on('click', function() {
      $(this).removeClass('active');
      $('.box_contentmenu').removeClass('active');
      $('.menuleft').removeClass('active');
      $('.box_contentmenu_background').removeClass('active');
	      $('body').removeClass('activemenu_mobile');
    });
  };




  function popup(){
    $('.jsclosepoup').on('click', function() {
      $('.jsengo_popup').addClass('d-none');

    });
  }
  function cookiepopup(){
    if (!jQuery.cookie('brilliant_pop_newletter') || jQuery.cookie('brilliant_pop_newletter') == null) {    
      $(window).on('load', function(){
        setTimeout($('.jsengo_popup').show(), 300 * 1000);
        jQuery('.jsclosepoup').click(function(e) {
          e.preventDefault();
          jQuery('.jsengo_popup').hide(); 
          jQuery.cookie('brilliant_pop_newletter', '1', {expires: 1, path:'/', domain: '' });
                                                        });
        });
      } else {
                   $('.jsengo_popup').remove();
    }
  }


  // Scroll to TOP
  function totop(){
    var back_to_top = $('#back-to-top');
    if (back_to_top.length) {
      var scrollTrigger = 100, // px
          backToTop = function() {
            var scrollTop = $(window).scrollTop();
            if (scrollTop > scrollTrigger) {
              back_to_top.addClass('show');
            } else {
              back_to_top.removeClass('show');
            }
          };
      $(window).on('scroll', function() {
        backToTop();
      });
      back_to_top.on('click', function(e) {
        e.preventDefault();
        $('html,body').animate({
          scrollTop: 0
        }, 700);
      });
    }
  }


  function popup2(){
    $('.jsclose_cookie').on('click', function() {
      $('.jscookie_popup').addClass('d-none');

    });
  }

  function jsmenu_fullwidth(){
    var top = $('.js_height_hd').offset();
    var height = $('.js_height_hd').outerHeight();
    $('.js-full-width').css({'top' : top.top + height - 15 ,'position' : 'fixed' , 'left' :' 0' , 'right' : '0', 'width' : '100%' })

    $(window).scroll(function() {
      var height = $('.js_height_hd').outerHeight();
      if ($(window).scrollTop() >= height){      
        $('.js-full-width').css({'top' : height - 15 })
      }
      else{
        $('.js-full-width').css({'top' : top.top + height - 15  })
      }     
    });
  }
  
  function cookiepopup2() {
    if (!jQuery.cookie('cookie_popup') || jQuery.cookie('cookie_popup') == null) {    
      $(window).on('load', function(){
        setTimeout($('.jscookie_popup').show(), 300 * 1000);
        jQuery('.jsclose_cookie').click(function(e) {
          e.preventDefault();
          jQuery('.jscookie_popup').hide(); 
          jQuery.cookie('cookie_popup', '1', {expires: 1, path:'/', domain: '' });
                                             });
        });
      } else {
                   $('.jscookie_popup').remove();
    }
  }

  
  jsmenu_fullwidth();
  totop();
        // Back-to-top placement helper is defined later and attached to window.
        // Guard to avoid breaking all JS if it's not available for any reason.
        if (window.positionBackToTopNearChat) {
          window.positionBackToTopNearChat();
        }
  jslogindestop();
  jscalllogindestop();
  popup();
  cookiepopup();
  popup2();
  cookiepopup2();
  menumobile();
  jsBackLogin();
  mobilescroll();
  menutoolbar();
  jsmenuiconh();
  menuhorizon();
  minicart();
  search();
  promo();

});

      
	      // (Removed) Ajax add-to-cart popup no longer requires a terms checkbox.

      ///////ZOOM IMAGE

      


(function($){
  $(function(){
    "use strict";

    // Mobile horizon menu open/close (from template vendor code; converted to namespaced handlers).
    function js_menu_horiontal(){
      var $overlay = $('.bg-mobile-menu');
      var $menu = $('.tab-menu-mobile');

      $('.js-link-click')
        .off('click.esHMenu')
        .on('click.esHMenu', function(){
          $overlay.addClass('active');
          $menu.addClass('active');
        });

      $('.js-header-mobile-menu')
        .off('click.esHMenu')
        .on('click.esHMenu', function(){
          $overlay.removeClass('active');
          $menu.removeClass('active');
        });
    }

    // Popup recommended products slider (appears in ajax add-to-cart popup).
    function productnewh5(){
      var $el = $('.slick_product_new-h5');
      if (!$el.length) return;
      if ($el.hasClass('slick-initialized')) return;
      if (!$el.slick) return;

      $el.slick({
        arrows: true,
        infinite: false,
        dots: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 3,
        autoplay: true,
        autoplaySpeed: 2000,
        prevArrow:'<button type="button" class="prev-slide"><i class="fa-solid fa-angle-left"></i></button>',
        nextArrow:'<button type="button" class="next-slide"><i class="fa-solid fa-angle-right"></i></button>',
        responsive: [
          { breakpoint: 1200, settings: { slidesToShow: 3, arrows: true, infinite: false, dots: false } },
          { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 2 } },
          { breakpoint: 600,  settings: { slidesToShow: 2, arrows: true, infinite: false, dots: false } }
        ]
      });
    }

    // Toolbar icon "active" indicator on scroll (used by snippets/menu-toolbar.liquid).
    function jstoolbarScroll(){
      var ns = 'scroll.esToolbarIcon';
      $(window).off(ns).on(ns, function(){
        if ($(window).scrollTop() > 130) {
          $('.js-toolbar-icon').addClass('active');
        } else {
          $('.js-toolbar-icon').removeClass('active');
        }
      });
      $(window).triggerHandler('scroll');
    }

    js_menu_horiontal();
    productnewh5();
    jstoolbarScroll();
  });
})(window.jQuery);


// Back-to-top positioning near Shopify Inbox
// =========================================
(function () {
  function positionBackToTopNearChat() {
    var fab = document.getElementById('back-to-top');
    if (!fab) return;

    // prevent double-init
    if (fab.getAttribute('data-es-btt-init') === '1') return;
    fab.setAttribute('data-es-btt-init', '1');

    function clamp(n, min, max) {
      return Math.max(min, Math.min(max, n));
    }

    function isVisible(el) {
      if (!el) return false;
      var cs = window.getComputedStyle ? window.getComputedStyle(el) : null;
      if (cs && (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity || '1') === 0)) return false;
      var r = el.getBoundingClientRect ? el.getBoundingClientRect() : null;
      if (!r) return false;
      // avoid elements that are technically "visible" but not rendered
      if (r.width < 2 || r.height < 2) return false;
      return true;
    }

    function looksLikeLauncherRect(r) {
      if (!r) return false;
      // Launcher button should be a small fixed element near bottom-right.
      if (r.width < 32 || r.height < 32) return false;
      // Ignore giant wrappers/overlays/containers.
      if (r.width > 260 || r.height > 260) return false;

      // Must be in the bottom-right quadrant-ish.
      if (r.right < window.innerWidth - 320) return false;
      if (r.bottom < window.innerHeight - 320) return false;

      // Inside viewport
      if (r.bottom <= 0 || r.right <= 0) return false;
      if (r.top >= window.innerHeight || r.left >= window.innerWidth) return false;
      return true;
    }

    function uniqPush(arr, el) {
      if (!el) return;
      for (var i = 0; i < arr.length; i++) if (arr[i] === el) return;
      arr.push(el);
    }

    function collectCandidates() {
      var cands = [];

      // Known hooks (div/webcomponent)
      var known = document.querySelectorAll(
        '#shopify-chat, #ShopifyChat, shopify-chat, .shopify-chat,' +
        ' .ShopifyInboxLauncher, .ShopifyInbox__launcher, .ShopifyInbox__Launcher,' +
        ' .shopify-inbox__launcher, .shopify-inbox-launcher,' +
        ' [data-shopify-inbox], [data-shopify-chat],' +
        ' [id*="ShopifyInbox"], [class*="ShopifyInbox"], [id*="shopify-inbox"], [class*="shopify-inbox"]'
      );
      for (var i = 0; i < known.length; i++) uniqPush(cands, known[i]);

      // Buttons/links with obvious labels
      var btns = document.querySelectorAll('button[aria-label], button[title], a[aria-label], a[title]');
      for (var j = 0; j < btns.length; j++) {
        var b = btns[j];
        var lab = ((b.getAttribute('aria-label') || '') + ' ' + (b.getAttribute('title') || '')).toLowerCase();
        if (lab.indexOf('chat') !== -1 || lab.indexOf('inbox') !== -1 || lab.indexOf('message') !== -1) {
          uniqPush(cands, b);
        }
      }

      // Shopify Inbox commonly injects a small iframe for the launcher
      var iframes = document.querySelectorAll('iframe');
      for (var k = 0; k < iframes.length; k++) {
        var f = iframes[k];
        var src = (f.getAttribute('src') || '').toLowerCase();
        var title = (f.getAttribute('title') || '').toLowerCase();
        var id = (f.id || '').toLowerCase();
        var cls = (f.className || '').toLowerCase();
        var hay = src + ' ' + title + ' ' + id + ' ' + cls;
        if (hay.indexOf('shopify') !== -1 && (hay.indexOf('inbox') !== -1 || hay.indexOf('chat') !== -1 || hay.indexOf('messaging') !== -1)) {
          uniqPush(cands, f);
        }
      }

      return cands;
    }

    function scoreRect(r) {
      // Lower is better.
      var dx = Math.max(0, window.innerWidth - r.right);
      var dy = Math.max(0, window.innerHeight - r.bottom);
      var corner = dx * dx + dy * dy;
      var area = r.width * r.height;
      // prefer a "button-sized" element
      var sizePenalty = 0;
      if (r.width > 140 || r.height > 140) sizePenalty += 250000;
      return corner + area + sizePenalty;
    }

    function findShopifyInboxLauncher() {
	      // Shopify Inbox (current) injects a Web Component into the DOM, e.g.:
	      // <inbox-online-store-chat id="ShopifyChat" ... style="position:fixed; right:16px; bottom:80px;"/>
	      // The clickable launcher is inside its shadowRoot, so we must anchor to the
	      // host element (NOT query inside shadow). Prefer it if present.
	      try {
	        var inboxHost = document.querySelector('inbox-online-store-chat, #ShopifyChat, #shopify-chat inbox-online-store-chat');
	        if (inboxHost && isVisible(inboxHost)) return inboxHost;
	      } catch (e) {}

	      var candidates = [];

      function pushAll(nodeList) {
        try {
          Array.prototype.forEach.call(nodeList, function (el) {
            if (el) candidates.push(el);
          });
        } catch (e) {}
      }

      // Known Shopify Inbox / Chat wrapper patterns
      var selectors = [
        '#shopify-chat',
        '#ShopifyChat',
        '#ShopifyInbox',
        '#ShopifyInboxLauncher',
        '.shopify-chat',
        '.ShopifyInbox__launcher',
        '.ShopifyInboxLauncher',
        '.shopify-inbox__launcher',
        '[data-shopify-chat]',
        '[data-shopify-inbox]',
        '[data-inbox-launcher]',
        'button[aria-label*="chat" i]',
        'button[title*="chat" i]',
        'a[aria-label*="chat" i]',
        'a[title*="chat" i]'
      ];

      selectors.forEach(function (sel) {
        try {
          pushAll(document.querySelectorAll(sel));
        } catch (e) {}
      });

      // Iframes (Shopify Inbox is often an injected iframe)
      var iframes = Array.prototype.slice.call(document.querySelectorAll('iframe'));
      iframes.forEach(function (f) {
        try {
          var src = (f.getAttribute('src') || '').toLowerCase();
          var title = (f.getAttribute('title') || '').toLowerCase();
          var id = (f.id || '').toLowerCase();
          var cls = (f.className || '').toString().toLowerCase();

          var looksLikeInbox = (
            (src.includes('shopify') && (src.includes('inbox') || src.includes('chat') || src.includes('messaging'))) ||
            title.includes('inbox') ||
            title.includes('chat') ||
            id.includes('inbox') ||
            id.includes('chat') ||
            cls.includes('inbox') ||
            cls.includes('chat')
          );

          if (looksLikeInbox) candidates.push(f);
        } catch (e) {}
      });

      // Fallback: any fixed element with chat/inbox-ish naming
      var likely = Array.prototype.slice.call(document.querySelectorAll('button, a, div'));
      for (var i = 0; i < likely.length; i++) {
        var el = likely[i];
        try {
          var cn = (el.className || '').toString().toLowerCase();
          var id2 = (el.id || '').toLowerCase();
          var aria = (el.getAttribute('aria-label') || '').toLowerCase();
          if (!(cn.includes('chat') || cn.includes('inbox') || id2.includes('chat') || id2.includes('inbox') || aria.includes('chat') || aria.includes('inbox'))) {
            continue;
          }
          var st = window.getComputedStyle(el);
          if (st.position !== 'fixed') continue;
          var r = el.getBoundingClientRect();
          if (!rectLooksValid(r)) continue;
          candidates.push(el);
        } catch (e) {}
      }

      // De-duplicate
      var seen = new Set();
      var uniq = [];
      candidates.forEach(function (el) {
        if (!el) return;
        if (seen.has(el)) return;
        seen.add(el);
        uniq.push(el);
      });

      var best = null;
      var bestScore = 1e18;

      function scoreRect(r) {
        var dx = Math.max(0, window.innerWidth - r.right);
        var dy = Math.max(0, window.innerHeight - r.bottom);
        var corner = dx * dx + dy * dy;
        var area = r.width * r.height;

        var penalty = 0;
        // Reject huge containers (common when the provider uses a full-height iframe)
        if (r.width > 260 || r.height > 260) penalty += 8e8;
        // Too small / invisible-ish
        if (r.width < 36 || r.height < 36) penalty += 5e8;
        // Must be in the bottom-right quadrant
        if (r.right < window.innerWidth - 320) penalty += 8e8;
        if (r.bottom < window.innerHeight - 320) penalty += 8e8;

        return corner + area + penalty;
      }

      for (var j = 0; j < uniq.length; j++) {
        var el2 = uniq[j];
        try {
          if (!isVisible(el2)) continue;
          var r2 = el2.getBoundingClientRect();
          if (!rectLooksValid(r2)) continue;
          var s = scoreRect(r2);
          if (s < bestScore) {
            bestScore = s;
            best = el2;
          }
        } catch (e) {}
      }

      return best;
    }

    var scheduled = false;
    var observedEl = null;
    var ro = null;

    function scheduleUpdate() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        updatePosition();
      });
    }

    function ensureResizeObserver(target) {
      if (!window.ResizeObserver) return;
      if (!target) return;
      if (observedEl === target) return;
      observedEl = target;
      if (ro) {
        try { ro.disconnect(); } catch (e) {}
      }
      ro = new ResizeObserver(scheduleUpdate);
      try { ro.observe(target); } catch (e) {}
    }

    function updatePosition() {
      var isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;

      // Defaults (when chat launcher cannot be detected yet)
      var defaultRight = isMobile ? 16 : 18;
      var defaultBottom = isMobile ? 120 : 128;

      // ES-like spacing between arrow and chat launcher
      var gapY = isMobile ? 10 : 12;

	      var right = defaultRight;
	      var bottom = defaultBottom;
	      var anchoredToChat = false;

	      var chatEl = findShopifyInboxLauncher();
	      if (chatEl) {
        var r = chatEl.getBoundingClientRect();
        if (looksLikeLauncherRect(r)) {
          // Align to the chat launcher's right edge (ES-like)
          var chatRightDistance = Math.round(window.innerWidth - r.right);
          right = clamp(chatRightDistance, defaultRight, isMobile ? 72 : 88);

          // Place directly above the chat launcher with a small vertical gap
          var chatTopFromBottom = Math.round(window.innerHeight - r.top);
          bottom = clamp(chatTopFromBottom + gapY, isMobile ? 72 : 84, isMobile ? 240 : 260);
	          anchoredToChat = true;

          ensureResizeObserver(chatEl);
        }
      }

	      // Important: use the detected launcher's real on-screen position as the source of truth.
	      // Do NOT add safe-area env() here, otherwise the arrow can "drift" relative to Inbox
	      // on some iOS devices (Inbox already accounts for its own offsets).
	      if (anchoredToChat) {
	        fab.style.right = right + 'px';
	        fab.style.bottom = bottom + 'px';
	      } else {
	        fab.style.right = 'calc(' + right + 'px + env(safe-area-inset-right))';
	        fab.style.bottom = 'calc(' + bottom + 'px + env(safe-area-inset-bottom))';
	      }
    }

    // Initial + reactive positioning
    scheduleUpdate();

    // "Kick" adjustments for late-injected widgets (Shopify Inbox often loads after render)
    var kick = 0;
    (function kickLoop() {
      scheduleUpdate();
      kick++;
      if (kick < 30) setTimeout(kickLoop, 120);
    })();

    window.addEventListener('resize', scheduleUpdate, { passive: true });
    window.addEventListener('orientationchange', scheduleUpdate, { passive: true });
    window.addEventListener('scroll', scheduleUpdate, { passive: true });

    if (window.MutationObserver) {
      var mo = new MutationObserver(scheduleUpdate);
      mo.observe(document.documentElement, { childList: true, subtree: true, attributes: true });
    }
  }

	  // Expose helper globally (so other scripts can call it without ReferenceError)
	  window.positionBackToTopNearChat = positionBackToTopNearChat;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', positionBackToTopNearChat);
  } else {
    positionBackToTopNearChat();
  }
})();
